import React, { useState, useEffect } from "react";
import { Input, Button, message, Typography, Spin, Table, Checkbox, Tag, Image, Progress, Switch, ConfigProvider, theme } from "antd";
import {
  CheckCircleOutlined, ArrowLeftOutlined, SearchOutlined, CheckOutlined, EnvironmentOutlined,
  ClockCircleOutlined, BulbOutlined, BulbFilled, ThunderboltOutlined, NodeIndexOutlined,
  AimOutlined, BarChartOutlined, RightOutlined, FullscreenOutlined, FullscreenExitOutlined,
} from "@ant-design/icons";
import axios from "axios";
import config from "../config";
import moment from "moment";
import Cookies from "js-cookie";
const { Text } = Typography;

const warehouseMap = {
  sections: [
    { id: '1', name: '1', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '2', name: '2', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '3', name: '3', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '4', name: '4', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '5', name: '5', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '6', name: '6', rows: ['A', 'B', 'C', 'D', 'E'] },
    { id: '7', name: '7', rows: ['A', 'B', 'C', 'D'] },
    { id: '13', name: '13', rows: ['A', 'B', 'C', 'D'] },
    { id: '14', name: '14', rows: ['A', 'B', 'C', 'D'] },
    { id: '16', name: '16', rows: ['A', 'B', 'C', 'D'] },
    { id: '17', name: '17', rows: ['A', 'B', 'C'] },
    { id: '18', name: '18', rows: ['B', 'C'] },
    { id: '19', name: '19', rows: ['A', 'B', 'C'] },
    { id: '20', name: '20', rows: ['A', 'B', 'C', 'D'] },
    { id: '21', name: '21', rows: ['A', 'B', 'C', 'D'] },
    { id: '22', name: '22', rows: ['A', 'B', 'C', 'D'] },
    { id: '24', name: '24', rows: ['A', 'B', 'C', 'D'] },
    { id: '25', name: '25', rows: ['A', 'B', 'C', 'D'] },
    { id: '26', name: '26', rows: ['A', 'B', 'C', 'D'] },
    { id: '27', name: '27', rows: ['A', 'B', 'C', 'D'] },
    { id: '28', name: '28', rows: ['A', 'B', 'C', 'D'] },
    { id: '29', name: '29', rows: ['A', 'B', 'C', 'D'] },
    { id: '30', name: '30', rows: ['A', 'B', 'C', 'D'] },
    { id: '31', name: '31', rows: ['A', 'B', 'C', 'D'] },
    { id: '44', name: '44', rows: ['A', 'B', 'C', 'D'] },
    { id: '48', name: '48', rows: ['A', 'B', 'C', 'D'] }
  ]
};

// Demo data for preview (only used when no orders prop is passed)
const demoOrders = [
  {
    orderID: "S49640",
    customer: { name: "John Doe", email: "john@example.com" },
    picked_status: "Not Picked",
    packed_status: "Not Packed",
    products: [
      { _id: "1", name: "Premium Coffee Beans 1kg", sku: "1KG-COF-001", quantity: 2, productLocation: "5A", productCategory: "Beverages", imageUrl: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=100&h=100&fit=crop" },
      { _id: "2", name: "Organic Green Tea", sku: "TEA-GRN-002", quantity: 1, productLocation: "5B", productCategory: "Beverages", imageUrl: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=100&h=100&fit=crop" },
      { _id: "3", name: "Dark Chocolate Bar", sku: "CHC-DRK-003", quantity: 3, productLocation: "7A", productCategory: "Snacks", imageUrl: "https://images.unsplash.com/photo-1511381939415-e44015466834?w=100&h=100&fit=crop" },
      { _id: "4", name: "Almond Butter", sku: "NUT-ALM-004", quantity: 1, productLocation: "13B", productCategory: "Spreads", imageUrl: "https://images.unsplash.com/photo-1520991906436-b28e4f59b5ce?w=100&h=100&fit=crop" }
    ]
  }
];

const formatDuration = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const p = (n) => String(n).padStart(2, "0");
  return `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
};

const PickingPage = ({
  orders: ordersProp,
  userName: userNameProp = "",
  refetch = () => {},
  darkTheme = false
}) => {
  const userName = userNameProp || Cookies.get("userName") || "Demo User";
  const [pickingOrders, setPickingOrders] = useState(Array.isArray(ordersProp) ? ordersProp : []);
  const orders = Array.isArray(ordersProp) ? ordersProp : pickingOrders;
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [pickedItems, setPickedItems] = useState({});
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [pickRoute, setPickRoute] = useState([]);
  const [isDarkTheme, setIsDarkTheme] = useState(darkTheme);
  const [now, setNow] = useState(Date.now()); // UI-only: drives the duration display
  const [isExpanded, setIsExpanded] = useState(false); // in-app "pop out" mode, like a video player's expand
  const [searchError, setSearchError] = useState("");

  useEffect(() => {
    if (!isExpanded) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setIsExpanded(false); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isExpanded]);

  const toggleExpand = () => setIsExpanded(v => !v);

  // Validation wrapper only; the original handleSearch() is untouched.
  const onSearchSubmit = (value) => {
    if (!value || !value.trim()) {
      setSearchError("Enter an Order ID or AWB code to search.");
      return;
    }
    setSearchError("");
    handleSearch(value);
  };

  useEffect(() => { setIsDarkTheme(darkTheme); }, [darkTheme]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (selectedOrder) {
      setStartTime(new Date());
      generatePickRoute(selectedOrder.products);
    }
  }, [selectedOrder]);

  useEffect(() => {
    if (!selectedOrder) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [selectedOrder]);

  const handleBack = () => {
    setSelectedOrder(null);
    setStartTime(null);
    setPickRoute([]);
    setPickedItems({});
  };

  const parseLocation = (loc) => {
    if (!loc) return { section: 0, row: '', raw: 'Unknown' };
    const cleaned = loc.toString().trim().toUpperCase();
    const match = cleaned.match(/^(\d+)([A-Z]*)$/);
    if (!match) return { section: 0, row: '', raw: cleaned };
    return { section: parseInt(match[1], 10), row: match[2] || '', raw: cleaned };
  };

  const generatePickRoute = (products) => {
    const locations = products.map(p => parseLocation(p.productLocation).raw);
    const sortedLocations = [...new Set(locations)].sort((a, b) => {
      const locA = parseLocation(a);
      const locB = parseLocation(b);
      if (locA.section !== locB.section) return locA.section - locB.section;
      return locA.row.localeCompare(locB.row);
    });
    setPickRoute(sortedLocations);
  };

  const handleSearch = async (value) => {
    const trimmedValue = value.trim();
    setLoading(true);
    try {
      const token = Cookies.get("token") || localStorage.getItem("token");
      const response = await axios.get(
        `${config.apiBaseUrl}/picking/order/${encodeURIComponent(trimmedValue)}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const order = response.data?.order;
      setPickingOrders(order ? [order] : []);

      const isEligible = order &&
        (!order.picked_status || order.picked_status === "Not Picked") &&
        order.packed_status !== "Completed" &&
        order.packed_status !== "Hold" &&
        order.packed_status !== "Cancelled";

      if (isEligible) {
        setSelectedOrder(order);
        const initialPicked = {};
        order.products.forEach((_, index) => (initialPicked[index] = false));
        setPickedItems(initialPicked);
        setSearchText("");
      } else if (order?.packed_status === "Completed") {
        message.error("This order is already packed and cannot be picked again.");
      } else if (order?.packed_status === "Hold") {
        message.error("This order is on hold and cannot be picked.");
      } else if (order?.packed_status === "Cancelled") {
        message.error("This order is cancelled and cannot be picked.");
      } else {
        message.error("Order not found, already picked, or already packed.");
      }
    } catch (error) {
      setPickingOrders([]);
      message.error(error.response?.status === 404 ? "Order not found, already picked, or already packed." : "Failed to search order.");
    } finally {
      setLoading(false);
    }
  };

  const handlePickToggle = (index) => {
    setPickedItems(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const allPicked = Object.values(pickedItems).every((val) => val);
  const pickedCount = Object.values(pickedItems).filter(Boolean).length;
  const totalCount = Object.keys(pickedItems).length;
  const progressPercent = totalCount > 0 ? Math.round((pickedCount / totalCount) * 100) : 0;

  const toggleSelectAll = () => {
    const newState = {};
    const newPickedValue = !allPicked;
    selectedOrder.products.forEach((_, index) => { newState[index] = newPickedValue; });
    setPickedItems(newState);
  };

  const handlePickOrder = async (orderID) => {
    setLoading(true);
    const endTime = new Date();
    if (!userName) {
      message.error("User name is missing. Please sign in again.");
      setLoading(false);
      return;
    }
    if (!startTime) {
      message.error("Start time is missing. Please re-select the order.");
      setLoading(false);
      return;
    }
    if (!selectedOrder || !selectedOrder.products || !Array.isArray(selectedOrder.products)) {
      message.error("Order or products missing. Please try again.");
      setLoading(false);
      return;
    }
    const pickingActivity = {
      username: userName,
      orderID,
      products: selectedOrder.products.map((product) => ({
        name: product.name,
        sku: product.sku || "N/A",
        quantity: product.quantity,
      })),
      status: "Completed",
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
    };
    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/pick-order`,
        {
          orderID,
          picked_person_name: userName,
          picked_date: new Date(),
          picked_time: moment().format("HH:mm:ss"),
          pickingActivity,
        },
        { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
      );
      if (response.status === 200) {
        if (Array.isArray(ordersProp)) {
          refetch();
        } else {
          setPickingOrders([]);
        }
        setSelectedOrder(null);
        setStartTime(null);
        message.success(`Order ${orderID} marked as Picked by ${userName}`);
      }
    } catch (error) {
      message.error("Failed to mark order as Picked");
    } finally {
      setLoading(false);
    }
  };

  const toggleTheme = () => setIsDarkTheme(!isDarkTheme);

  const sortedProducts = selectedOrder
    ? [...selectedOrder.products].sort((a, b) => {
        const aLoc = parseLocation(a.productLocation);
        const bLoc = parseLocation(b.productLocation);
        if (aLoc.section !== bLoc.section) return aLoc.section - bLoc.section;
        return aLoc.row.localeCompare(bLoc.row);
      })
    : [];

  const nextUnpickedIndex = sortedProducts.findIndex((_, idx) => !pickedItems[idx]);
  const nextProduct = nextUnpickedIndex !== -1 ? sortedProducts[nextUnpickedIndex] : null;

  // ---------- helpers for display ----------
  const LocationTag = ({ loc, highlight }) => {
    const unknown = !loc || loc === "Unknown";
    return (
      <Tag className={unknown ? "tgh-tag-neutral" : highlight ? "tgh-tag-next" : "tgh-tag-loc"}
        icon={unknown ? null : <EnvironmentOutlined />}>
        {unknown ? "Unknown" : loc}
      </Tag>
    );
  };

  const isNextRecord = (record) => !record.picked && record.index === nextUnpickedIndex;

  // ---------- route guide (same logic, compact design) ----------
  const renderWarehouseMap = () => {
    if (!selectedOrder) return null;
    const nextLoc = nextProduct ? parseLocation(nextProduct.productLocation).raw : null;
    const pickedLocs = new Set();
    sortedProducts.forEach((p, idx) => { if (pickedItems[idx]) pickedLocs.add(parseLocation(p.productLocation).raw); });
    // a location is done only when every product at it is picked
    const doneLocs = pickRoute.filter(loc =>
      sortedProducts.every((p, idx) => parseLocation(p.productLocation).raw !== loc || pickedItems[idx])
    );
    const pendingLocs = pickRoute.filter(loc => !doneLocs.includes(loc));
    const upcoming = pendingLocs.find(l => l !== nextLoc);
    const routePct = pickRoute.length ? Math.round((doneLocs.length / pickRoute.length) * 100) : 0;

    return (
      <section className="tgh-card tgh-route">
        <div className="tgh-card-title"><NodeIndexOutlined /> Pick route</div>
        <div className="tgh-route-row">
          <div className="tgh-route-stop is-current">
            <span className="tgh-label">Current</span>
            <strong>{nextLoc || "Done"}</strong>
          </div>
          <RightOutlined className="tgh-route-arrow" />
          <div className="tgh-route-stop">
            <span className="tgh-label">Next</span>
            <strong>{upcoming || "—"}</strong>
          </div>
        </div>
        <div className="tgh-route-chips">
          {pickRoute.map(loc => (
            <span key={loc} className={`tgh-chip ${doneLocs.includes(loc) ? "done" : loc === nextLoc ? "now" : ""}`}>
              {loc}
            </span>
          ))}
        </div>
        <div className="tgh-muted tgh-small">{doneLocs.length} / {pickRoute.length} stops completed</div>
        <Progress percent={routePct} showInfo={false} size="small" strokeColor="var(--tgh-green)" trailColor="var(--tgh-track)" />
      </section>
    );
  };

  const columns = [
    {
      title: "", dataIndex: "checkbox", width: 48,
      render: (_, record) => <Checkbox checked={record.picked} onChange={() => handlePickToggle(record.index)} />,
    },
    {
      title: "Image", dataIndex: "imageUrl", width: 72,
      render: (url) => (
        <Image src={url || "https://via.placeholder.com/48"} alt="Product" width={48} height={48}
          style={{ objectFit: "cover", borderRadius: 8 }} preview fallback="https://via.placeholder.com/48" />
      ),
    },
    {
      title: "Product", dataIndex: "name",
      render: (text, record) => (
        <span className={record.picked ? "tgh-struck" : ""} style={{ fontWeight: 500 }}>{text}</span>
      ),
    },
    {
      title: "SKU", dataIndex: "sku", width: 170,
      render: (sku) => (
        <Tag className={sku && sku.toLowerCase().startsWith("1kg") ? "tgh-tag-warn" : "tgh-tag-neutral"}>{sku}</Tag>
      ),
    },
    {
      title: "Qty", dataIndex: "quantity", width: 80,
      render: (qty) => <Tag className={qty > 1 ? "tgh-tag-warn" : "tgh-tag-neutral"} style={{ fontWeight: 600 }}>{qty}</Tag>,
    },
    {
      title: "Location", dataIndex: "productLocation", width: 120,
      render: (loc, record) => <LocationTag loc={loc} highlight={isNextRecord(record)} />,
    },
    {
      title: "Category", dataIndex: "productCategory", width: 140,
      render: (cat) => <span className="tgh-muted">{cat}</span>,
    },
    {
      title: "Status", dataIndex: "picked", width: 110,
      render: (picked) => (
        <Tag className={picked ? "tgh-tag-done" : "tgh-tag-neutral"}
          icon={picked ? <CheckCircleOutlined /> : <ClockCircleOutlined />}>
          {picked ? "Picked" : "Pending"}
        </Tag>
      ),
    }
  ];

  const renderMobileProductItem = (item) => {
    const isNext = isNextRecord(item);
    const isPicked = item.picked;
    return (
      <div key={item.index} className={`tgh-mcard ${isPicked ? "picked" : ""} ${isNext ? "next" : ""}`}>
        <div className="tgh-mcard-top">
          <Image src={item.imageUrl || "https://via.placeholder.com/64"} alt="Product" width={64} height={64}
            style={{ objectFit: "cover", borderRadius: 8, flexShrink: 0 }} preview fallback="https://via.placeholder.com/64" />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className={`tgh-mname ${isPicked ? "tgh-struck" : ""}`}>{item.name}</div>
            <div className="tgh-muted tgh-small">{item.sku}</div>
            <div className="tgh-mtags">
              <Tag className={item.quantity > 1 ? "tgh-tag-warn" : "tgh-tag-neutral"}>Qty {item.quantity}</Tag>
              <LocationTag loc={item.productLocation} highlight={isNext} />
              <Tag className="tgh-tag-neutral">{item.productCategory}</Tag>
            </div>
          </div>
          <Checkbox checked={isPicked} onChange={() => handlePickToggle(item.index)} style={{ transform: 'scale(1.25)' }} />
        </div>
        <div className="tgh-mcard-foot">
          {isNext && <span className="tgh-next-badge">Next pick</span>}
          <Tag className={isPicked ? "tgh-tag-done" : "tgh-tag-neutral"} style={{ marginLeft: "auto", marginRight: 0 }}
            icon={isPicked ? <CheckCircleOutlined /> : <ClockCircleOutlined />}>
            {isPicked ? "Picked" : "Pending"}
          </Tag>
        </div>
      </div>
    );
  };

  // ---------- landing data (real order data only) ----------
  const isEligible = (o) =>
    (!o.picked_status || o.picked_status === "Not Picked") &&
    !["Completed", "Hold", "Cancelled"].includes(o.packed_status);
  const eligibleOrders = orders.filter(isEligible);
  const summary = [
    { label: "Awaiting pick", value: eligibleOrders.length },
    { label: "Picked", value: orders.filter(o => o.picked_status && o.picked_status !== "Not Picked").length },
    { label: "Packed", value: orders.filter(o => o.packed_status === "Completed").length },
    { label: "Items to pick", value: eligibleOrders.reduce((n, o) => n + (o.products || []).reduce((q, p) => q + (Number(p.quantity) || 0), 0), 0) },
  ];
  const features = [
    { icon: <SearchOutlined />, title: "Order search", text: "Quick order lookup" },
    { icon: <NodeIndexOutlined />, title: "Smart route", text: "Optimized picking path" },
    { icon: <BarChartOutlined />, title: "Live progress", text: "Track picking progress" },
    { icon: <AimOutlined />, title: "Accurate picking", text: "Reduce picking errors" },
  ];

  const ThemeSwitch = (
    <div className="tgh-controls">
      <Button
        className="tgh-expand-btn"
        icon={isExpanded ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={toggleExpand}
        aria-label={isExpanded ? "Exit expanded view" : "Expand to full screen"}
        title={isExpanded ? "Exit (Esc)" : "Expand"}
      >
        {isExpanded ? "Exit" : "Expand"}
      </Button>
      <Switch checked={isDarkTheme} onChange={toggleTheme}
        checkedChildren={<BulbFilled />} unCheckedChildren={<BulbOutlined />} />
    </div>
  );

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkTheme ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: { colorPrimary: "#1f8a4c", colorBgContainer: isDarkTheme ? "#172620" : "#ffffff" },
      }}
    >
    <div className={`tgh-pick ${isDarkTheme ? "dark" : "light"}${isExpanded ? " tgh-expanded" : ""}`}>
      {!selectedOrder ? (
        // ================= SCREEN 1: LANDING =================
        <div className="tgh-landing">
          <div className="tgh-landing-top">{ThemeSwitch}</div>
          <div className="tgh-landing-center">
            <div className="tgh-hero">
              <span className="tgh-eyebrow">Warehouse operations</span>
              <h1>Warehouse Picking</h1>
              <p>Search an Order ID or AWB to start picking.</p>
            </div>

            <section className="tgh-search" aria-label="Search order">
              <div className="tgh-search-band">
                <span className="tgh-search-icon"><SearchOutlined /></span>
                <div>
                  <div className="tgh-search-title">Find an order</div>
                  <div className="tgh-search-sub">Search by Order ID or AWB code</div>
                </div>
                <span className="tgh-pill"><span className="tgh-dot" />{eligibleOrders.length} awaiting pick</span>
              </div>
              <div className="tgh-search-body">
                <Input.Search
                  placeholder="Enter Order ID or AWB code"
                  value={searchText}
                  onChange={(e) => { setSearchText(e.target.value); if (searchError) setSearchError(""); }}
                  onSearch={onSearchSubmit}
                  prefix={<SearchOutlined />}
                  enterButton="Search"
                  size="large"
                  allowClear
                  autoFocus
                  status={searchError ? "error" : undefined}
                  className="tgh-search-input"
                />
                <div className="tgh-search-meta">
                  {searchError
                    ? <span className="tgh-error" role="alert">{searchError}</span>
                    : <span className="tgh-muted">Press <kbd>Enter</kbd> or tap Search. A partial ID works too.</span>}
                </div>
              </div>
              <ol className="tgh-steps">
                <li><b>1</b><span>Search the order</span></li>
                <li><b>2</b><span>Pick items in route order</span></li>
                <li><b>3</b><span>Complete picking</span></li>
              </ol>
            </section>

            <div className="tgh-summary">
              {summary.map(s => (
                <div key={s.label}><strong>{s.value}</strong><span>{s.label}</span></div>
              ))}
            </div>

            <div className="tgh-features">
              {features.map(f => (
                <div key={f.title} className="tgh-feature">
                  <span className="tgh-feature-icon">{f.icon}</span>
                  <span><strong>{f.title}</strong>{f.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        // ================= SCREEN 2: ACTIVE PICKING =================
        <Spin spinning={loading} size="large">
          <div className="tgh-active">
            <header className="tgh-active-head">
              <Button type="text" icon={<ArrowLeftOutlined />} onClick={handleBack} aria-label="Back to search" />
              <div style={{ minWidth: 0 }}>
                <div className="tgh-order-id">{selectedOrder.orderID}</div>
                <div className="tgh-muted tgh-small"><ClockCircleOutlined /> Started: {startTime?.toLocaleTimeString()}</div>
              </div>
              <Tag className={allPicked ? "tgh-tag-done" : "tgh-tag-next"} style={{ marginLeft: 8 }}>
                {allPicked ? "Ready to complete" : "In progress"}
              </Tag>
              <div style={{ marginLeft: "auto" }}>{ThemeSwitch}</div>
            </header>

            <section className="tgh-card">
              <div className="tgh-progress-line">
                <span>{pickedCount} of {totalCount} items picked · {progressPercent}%</span>
              </div>
              <Progress percent={progressPercent} showInfo={false} strokeColor="var(--tgh-green)" trailColor="var(--tgh-track)" />
            </section>

            <section className="tgh-info">
              <div><span className="tgh-label">Customer</span><strong>{selectedOrder.customer?.name}</strong></div>
              <div><span className="tgh-label">Email</span><strong className="tgh-ellipsis">{selectedOrder.customer?.email}</strong></div>
              <div><span className="tgh-label">Products</span><strong>{totalCount}</strong></div>
              <div><span className="tgh-label">Picked</span><strong>{pickedCount} / {totalCount}</strong></div>
              <div><span className="tgh-label">Duration</span><strong>{startTime ? formatDuration(now - startTime.getTime()) : "00:00:00"}</strong></div>
            </section>

            <div className="tgh-active-grid">
              <section className="tgh-card tgh-current">
                <div className="tgh-card-title">Next pick</div>
                {nextProduct ? (
                  <div className="tgh-current-body">
                    <Image src={nextProduct.imageUrl || "https://via.placeholder.com/72"} alt="Product" width={72} height={72}
                      style={{ objectFit: "cover", borderRadius: 10 }} preview fallback="https://via.placeholder.com/72" />
                    <div style={{ minWidth: 0 }}>
                      <div className="tgh-current-name">{nextProduct.name}</div>
                      <div className="tgh-muted tgh-small">{nextProduct.sku || "N/A"}</div>
                      <div className="tgh-mtags">
                        <Tag className={nextProduct.quantity > 1 ? "tgh-tag-warn" : "tgh-tag-neutral"}>Qty {nextProduct.quantity}</Tag>
                        <LocationTag loc={parseLocation(nextProduct.productLocation).raw} highlight />
                        <Tag className="tgh-tag-neutral">Pending</Tag>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="tgh-muted">All items picked. Complete picking to finish.</div>
                )}
              </section>
              {renderWarehouseMap()}
            </div>

            <section className="tgh-card">
              <div className="tgh-card-head">
                <div className="tgh-card-title">Products to pick</div>
                <Checkbox onChange={toggleSelectAll} checked={allPicked}>{allPicked ? "Unselect all" : "Select all"}</Checkbox>
              </div>

              {isMobile ? (
                sortedProducts.map((product, index) =>
                  renderMobileProductItem({
                    key: index,
                    name: product.name,
                    sku: product.sku || "N/A",
                    quantity: product.quantity,
                    picked: pickedItems[index],
                    index,
                    imageUrl: product.imageUrl || "",
                    productLocation: product.productLocation || "Unknown",
                    productCategory: product.productCategory || "Unknown",
                  })
                )
              ) : (
                <Table
                  size="middle"
                  dataSource={sortedProducts.map((product, index) => ({
                    key: index,
                    name: product.name,
                    sku: product.sku || "N/A",
                    quantity: product.quantity,
                    picked: pickedItems[index],
                    index,
                    imageUrl: product.imageUrl || "",
                    productLocation: product.productLocation || "Unknown",
                    productCategory: product.productCategory || "Unknown",
                  }))}
                  columns={columns}
                  pagination={false}
                  scroll={{ x: 800 }}
                  rowClassName={(record) => (record.picked ? "picked-row" : isNextRecord(record) ? "next-row" : "")}
                />
              )}
            </section>

            <div className="tgh-action-bar">
              <Button
                type="primary"
                size="large"
                icon={<CheckOutlined />}
                onClick={() => handlePickOrder(selectedOrder.orderID)}
                disabled={!allPicked || loading}
                block
                className="tgh-complete"
              >
                {allPicked ? "Complete Picking" : `Pick ${totalCount - pickedCount} More Items`}
              </Button>
            </div>
          </div>
        </Spin>
      )}

      <style>{`
        .tgh-pick { --tgh-green:#1f8a4c; --tgh-green-d:#14532d; --tgh-soft:#e8f5ec; --tgh-bg:#f3f7f4; --tgh-card:#fff; --tgh-text:#14301f; --tgh-muted:#5f7a6b; --tgh-line:#e1ebe4; --tgh-warn:#b45309; --tgh-warn-bg:#fef3e2; --tgh-solid:#1b7a43; --tgh-track:#d3e2d8; --tgh-error:#c0392b;
          width:100%; max-width:none; min-height:calc(100vh - 64px); background:var(--tgh-bg); color:var(--tgh-text); padding:20px 24px; box-sizing:border-box; }
        .tgh-pick.dark { --tgh-green:#3fb56c; --tgh-green-d:#1f8a4c; --tgh-soft:#1d3328; --tgh-bg:#0f1a14; --tgh-card:#172620; --tgh-text:#ffffff; --tgh-muted:#c3d4ca; --tgh-line:#264034; --tgh-warn:#f5b45a; --tgh-warn-bg:#3a2d15; --tgh-solid:#1b7a43; --tgh-track:#47685a; --tgh-error:#ff8a80; }
        .tgh-pick *, .tgh-pick *::before, .tgh-pick *::after { box-sizing:border-box; }
        .tgh-muted { color:var(--tgh-muted); } .tgh-small { font-size:12.5px; }
        .tgh-label { display:block; font-size:12px; color:var(--tgh-muted); }
        .tgh-struck { text-decoration:line-through; color:var(--tgh-muted); }
        .tgh-ellipsis { display:block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        .tgh-card { background:var(--tgh-card); border:1px solid var(--tgh-line); border-radius:12px; padding:16px 18px; margin-bottom:16px; box-shadow:0 1px 3px rgba(20,48,31,.06); }
        .tgh-card-head { display:flex; align-items:center; justify-content:space-between; margin-bottom:12px; gap:12px; }
        .tgh-card-title { font-weight:600; font-size:15px; display:flex; align-items:center; gap:8px; color:var(--tgh-text) !important; }
        .tgh-pick.dark .tgh-card-title { color:#ffffff !important; }
        .tgh-card-title .anticon { color:var(--tgh-green); }

        .tgh-landing, .tgh-active { width:100%; }
        .tgh-controls { display:flex; align-items:center; gap:10px; }
        .tgh-icon-btn { color:var(--tgh-text) !important; }
        .tgh-landing { display:flex; flex-direction:column; min-height:calc(100vh - 104px); }
        .tgh-landing-top { display:flex; justify-content:flex-end; }
        .tgh-landing-center { flex:1; display:flex; flex-direction:column; justify-content:center; align-items:center; width:100%; max-width:960px; margin:0 auto; padding:16px 0 32px; }
        .tgh-hero { text-align:center; margin-bottom:22px; }
        .tgh-eyebrow { font-size:13px; color:var(--tgh-green); font-weight:600; }
        .tgh-hero h1 { color:var(--tgh-text); font-size:40px; line-height:1.1; margin:8px 0 8px; font-weight:700; }
        .tgh-hero p { margin:0; color:var(--tgh-muted); font-size:16px; }

        .tgh-search { width:100%; max-width:820px; background:var(--tgh-card); border:2px solid var(--tgh-green); border-radius:18px; overflow:hidden; margin-bottom:24px; box-shadow:0 14px 40px rgba(31,138,76,.22); }
        .tgh-search-band { display:flex; align-items:center; gap:14px; padding:18px 24px; background:var(--tgh-solid); color:#fff; }
        .tgh-search-icon { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,.2); display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0; }
        .tgh-search-title { font-size:20px; font-weight:700; line-height:1.2; }
        .tgh-search-sub { font-size:13px; opacity:.9; }
        .tgh-pill { margin-left:auto; display:flex; align-items:center; gap:8px; background:rgba(255,255,255,.18); border-radius:999px; padding:6px 14px; font-size:13px; font-weight:600; white-space:nowrap; }
        .tgh-dot { width:8px; height:8px; border-radius:50%; background:#b7f5cd; }
        .tgh-search-body { padding:24px 24px 14px; }
        .tgh-search-input { width:100%; }
        .tgh-search .ant-input-affix-wrapper { border-radius:12px 0 0 12px; height:60px; font-size:18px; }
        .tgh-search .ant-input { font-size:18px; }
        .tgh-search .ant-input-search-button { height:60px; border-radius:0 12px 12px 0 !important; background:var(--tgh-solid); border-color:var(--tgh-solid); min-width:124px; font-size:16px; font-weight:600; color:#fff; }
        .tgh-search .ant-input-search-button:hover { background:var(--tgh-green-d) !important; border-color:var(--tgh-green-d) !important; }
        .tgh-search-meta { margin-top:10px; font-size:13px; min-height:20px; }
        .tgh-search-meta kbd { background:var(--tgh-soft); border:1px solid var(--tgh-line); border-radius:5px; padding:1px 7px; font-size:12px; color:var(--tgh-text); }
        .tgh-error { color:var(--tgh-error); font-weight:500; }
        .tgh-steps { list-style:none; margin:0; padding:14px 24px 18px; display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; border-top:1px solid var(--tgh-line); background:var(--tgh-bg); }
        .tgh-steps li { display:flex; align-items:center; gap:10px; font-size:13px; color:var(--tgh-text); }
        .tgh-steps b { width:24px; height:24px; border-radius:50%; background:var(--tgh-soft); color:var(--tgh-green); display:flex; align-items:center; justify-content:center; font-size:12px; flex-shrink:0; border:1px solid var(--tgh-green); }

        .tgh-summary { width:100%; display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:12px; margin-bottom:12px; }
        .tgh-summary > div { background:var(--tgh-card); border:1px solid var(--tgh-line); border-radius:12px; padding:14px 16px; text-align:center; }
        .tgh-summary strong { display:block; font-size:26px; color:var(--tgh-green); }
        .tgh-summary span { font-size:12.5px; color:var(--tgh-muted); }

        .tgh-features { width:100%; display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:12px; }
        .tgh-feature { display:flex; gap:12px; align-items:center; background:var(--tgh-card); border:1px solid var(--tgh-line); border-radius:12px; padding:14px 16px; font-size:12.5px; color:var(--tgh-muted); }
        .tgh-feature strong { display:block; font-size:14px; color:var(--tgh-text); }
        .tgh-feature-icon { width:36px; height:36px; border-radius:10px; background:var(--tgh-soft); color:var(--tgh-green); display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:17px; }

        .tgh-active-head { display:flex; align-items:center; gap:8px; margin-bottom:14px; flex-wrap:wrap; }
        .tgh-order-id { font-size:20px; font-weight:700; line-height:1.2; }
        .tgh-progress-line { font-weight:600; margin-bottom:8px; }
        .tgh-info { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); gap:12px; background:var(--tgh-card); border:1px solid var(--tgh-line); border-radius:12px; padding:12px 16px; margin-bottom:16px; }
        .tgh-info strong { display:block; font-size:14px; }
        .tgh-active-grid { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:16px; align-items:stretch; }
        .tgh-current-body { display:flex; gap:14px; align-items:center; margin-top:12px; }
        .tgh-current-name { font-weight:600; font-size:16px; }
        .tgh-mtags { display:flex; gap:6px; flex-wrap:wrap; margin-top:8px; }
        .tgh-mtags .ant-tag { margin:0; }

        .tgh-route-row { display:flex; align-items:center; gap:14px; margin:12px 0; }
        .tgh-route-stop { flex:1; background:var(--tgh-bg); border:1px solid var(--tgh-line); border-radius:10px; padding:8px 12px; }
        .tgh-route-stop strong { font-size:20px; }
        .tgh-route-stop.is-current { background:var(--tgh-soft); border-color:var(--tgh-green); }
        .tgh-route-arrow { color:var(--tgh-muted); }
        .tgh-route-chips { display:flex; gap:6px; flex-wrap:wrap; margin-bottom:8px; }
        .tgh-chip { font-size:12px; padding:2px 10px; border-radius:999px; border:1px solid var(--tgh-line); color:var(--tgh-muted); }
        .tgh-chip.done { background:var(--tgh-soft); color:var(--tgh-green); border-color:transparent; text-decoration:line-through; }
        .tgh-chip.now { background:var(--tgh-solid); color:#fff; border-color:var(--tgh-solid); }

        .tgh-pick .ant-tag { border-radius:6px; font-weight:500; }
        .tgh-tag-neutral { background:var(--tgh-bg) !important; color:var(--tgh-muted) !important; border-color:var(--tgh-line) !important; }
        .tgh-tag-loc { background:var(--tgh-soft) !important; color:var(--tgh-green) !important; border:1px solid var(--tgh-green) !important; }
        .tgh-tag-next { background:var(--tgh-solid) !important; color:#fff !important; border-color:var(--tgh-solid) !important; }
        .tgh-tag-done { background:var(--tgh-soft) !important; color:var(--tgh-green) !important; border-color:var(--tgh-green) !important; }
        .tgh-tag-warn { background:var(--tgh-warn-bg) !important; color:var(--tgh-warn) !important; border-color:transparent !important; }

        .tgh-pick, .tgh-pick .ant-checkbox-wrapper, .tgh-pick .ant-input, .tgh-pick .ant-input-affix-wrapper, .tgh-pick .ant-table-cell, .tgh-pick .ant-spin-container { color:var(--tgh-text); }
        .tgh-pick .ant-input::placeholder { color:var(--tgh-muted); }
        .tgh-pick.dark .ant-input-affix-wrapper, .tgh-pick.dark .ant-input { background:#0f1a14; border-color:var(--tgh-line); }
        .tgh-pick.dark .ant-btn-text { color:#fff; }
        .tgh-pick .ant-table, .tgh-pick .ant-table-thead > tr > th, .tgh-pick .ant-table-tbody > tr > td { background:transparent; color:var(--tgh-text); border-color:var(--tgh-line); }
        .tgh-pick .ant-table-thead > tr > th { font-size:12px; color:var(--tgh-muted); font-weight:600; }
        .tgh-pick .ant-table-tbody > tr:hover > td { background:var(--tgh-soft) !important; }
        .tgh-pick .picked-row > td { opacity:.7; }
        .tgh-pick .next-row > td { background:var(--tgh-soft) !important; }
        .tgh-pick .ant-checkbox-inner { background:transparent; border:2px solid var(--tgh-muted); }
        .tgh-pick .ant-checkbox-checked .ant-checkbox-inner { background:var(--tgh-solid); border-color:var(--tgh-solid); }
        .tgh-pick .ant-switch { background:var(--tgh-track); }
        .tgh-pick .ant-switch-checked { background:var(--tgh-solid) !important; }
        .tgh-pick .ant-btn-text { color:var(--tgh-text); }
        .tgh-pick .ant-btn-text:hover { background:var(--tgh-soft) !important; color:var(--tgh-text) !important; }
        .tgh-pick .ant-input-clear-icon, .tgh-pick .ant-input-prefix { color:var(--tgh-muted); }
        .tgh-pick .ant-image-mask { color:#fff; }
        .tgh-pick :focus-visible { outline:3px solid var(--tgh-green); outline-offset:2px; }
        .tgh-expand-btn { background:var(--tgh-card) !important; color:var(--tgh-text) !important; border:1px solid var(--tgh-green) !important; font-weight:600; }
        .tgh-expand-btn:hover { background:var(--tgh-soft) !important; }
        .ant-image-preview-root .ant-image-preview-mask, .ant-image-preview-root .ant-image-preview-wrap { z-index:3000 !important; }
        .ant-message { z-index:3100 !important; }
        .tgh-pick.tgh-expanded { position:fixed; inset:0; z-index:2000; width:100vw; height:100vh; min-height:100vh; overflow:auto; padding:20px 28px; animation:tghPop .3s cubic-bezier(.2,.8,.2,1); }
        .tgh-pick.tgh-expanded .tgh-landing { min-height:calc(100vh - 40px); }
        @keyframes tghPop { from { opacity:0; transform:scale(.94); } to { opacity:1; transform:scale(1); } }
        @media (prefers-reduced-motion: reduce) { .tgh-pick.tgh-expanded { animation:none; } }
        .tgh-pick .ant-progress-bg { height:10px !important; }
        
        .tgh-mcard { border:1px solid var(--tgh-line); border-radius:12px; padding:12px; margin-bottom:10px; background:var(--tgh-card); }
        .tgh-mcard.next { border:2px solid var(--tgh-green); }
        .tgh-mcard.picked { background:var(--tgh-soft); }
        .tgh-mcard-top { display:flex; gap:12px; align-items:flex-start; }
        .tgh-mname { font-weight:600; font-size:14.5px; }
        .tgh-mcard-foot { display:flex; align-items:center; margin-top:10px; }
        .tgh-next-badge { font-size:11.5px; font-weight:600; background:var(--tgh-solid); color:#fff; border-radius:999px; padding:2px 10px; }

        .tgh-action-bar { margin-top:4px; }
        .tgh-complete { height:52px; font-size:16px; font-weight:600; border-radius:12px; background:var(--tgh-solid); border:none; color:#fff; }
        .tgh-complete:not(:disabled):hover { background:var(--tgh-green-d) !important; }
        .tgh-pick .ant-btn-primary:disabled.tgh-complete { background:var(--tgh-track) !important; color:var(--tgh-text) !important; opacity:.8; }

        @media (max-width:1199px) {
          .tgh-active-grid { grid-template-columns:1fr; }
        }
        @media (max-width:767px) {
          .tgh-pick { padding:12px; }
          .tgh-pick.tgh-expanded { padding:12px; }
          .tgh-search-band { padding:14px 16px; flex-wrap:wrap; }
          .tgh-search-body { padding:16px 16px 10px; }
          .tgh-search .ant-input-affix-wrapper, .tgh-search .ant-input-search-button { height:54px; }
          .tgh-steps { grid-template-columns:1fr; padding:12px 16px 14px; gap:8px; }
          .tgh-pill { margin-left:0; }
          .tgh-landing { min-height:calc(100vh - 80px); }
          .tgh-hero h1 { font-size:28px; }
          .tgh-search { padding:16px; }
          .tgh-summary, .tgh-features { grid-template-columns:repeat(2,minmax(0,1fr)); }
          .tgh-info { grid-template-columns:1fr 1fr; }
          .tgh-active-grid { grid-template-columns:1fr; }
          .tgh-action-bar { position:sticky; bottom:0; padding:10px 0; background:var(--tgh-bg); z-index:10; }
        }
        @media (max-width:420px) {
          .tgh-features { grid-template-columns:1fr; }
        }
      `}</style>
    </div>
    </ConfigProvider>
  );
};

export default PickingPage;
